export default "__VITE_ASSET__Ba_jL7uS__"